// extracted by mini-css-extract-plugin
export default {"btnConsultation":"BtnConsulation_btnConsultation__SChoH"};